import axios from "./index";

export default {
  getAll() {
    return axios.get("/v1/setting/categories");
  },
  getAllDropdown() {
    return axios.get("/public/categories");
  },
  create(data) {
    return axios.post(`/v1/setting/categories`, data);
  },
  update(uuid, data) {
    return axios.patch(`/v1/setting/categories/${uuid}`, data);
  },
  updateStatus(uuid) {
    return axios.patch(`/v1/setting/categories/${uuid}/update_status`);
  },
};
